// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3INKf","content":"styles_content__JCud3"};